<p>
    <label [attr.for]="'textarea_' + randomId">{{labelInput}}</label><span *ngIf="mandatory" class="mandatory">*</span>
    <textarea #dtextarea class="form-control" autocomplete="off" placeholder="{{ showPlaceholder ? 'Inserire '+labelInput : ''}}" [attr.id]="'textarea_' + randomId" (focus)="selectAll($event)"
        [(ngModel)]="_value" (ngModelChange)="modelChanged()" [disabled]="disabled || submitPending" [maxlength]="maxlength" [attr.aria-required]="mandatory" >
    </textarea>
</p>